/* eslint-disable no-useless-catch */
import { ToastNature } from '../common/types';
import Toast from '../components/Toast';
import { InvoiceShareMap } from './common/types';

export const triggerInvoiceShare = async (invoice: any) => {
  let text = '';
  for (const [key, value] of Object.entries(invoice)) {
    if (InvoiceShareMap.has(key)) {
      text = text.concat(`${InvoiceShareMap.get(key)}: ${value}\n\n`);
    }
  }
  text = text.concat(`${invoice.businessLevel}: ${invoice.businessNumber}`);
  try {
    navigator
      .share({
        title: 'Share Invoice',
        text,
      })
      .then(() => {
        // console.log('Shared')
        Toast.notify({
          description: 'Invoice successfully shared!',
          nature: ToastNature.SUCCESS,
        });
      })
      .catch((e) => {
        throw e;
      });
  } catch (e) {
    //  console.log('Failed to share');
    throw e;
  }
};
